import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Loader from "../../../components/Loader";
import EditableTable from "./NotificationTable";
import Modal from "../../../components/Modal";
import ChangeLog from "../../../components/ChangeLog";

import {
  fetchNotification,
  updateNotification,
  setPageSize,
} from "@/slices/notificationSlice/NotificationSlice";

import SimplePagination from "@/components/SimplePagination";
import PanelUserSearch from "@/components/PanelUserSearch";
import PageSizeSelector from "@/components/PageSizeSelector";
import AddNotification from "./AddNotification";
import UpdateNotification from "./UpdateNotification";

function Notification() {
  const dispatch = useDispatch();

  // ✅ FIXED: correct selector
  const {
    notificationList,
    currentPage,
    totalPages,
    status,
    search,
    pageSize,
  } = useSelector((state) => state.notificationData);

  const [selectedRow, setSelectedRow] = useState(null);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenUpdate, setIsModalOpenUpdate] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);

  const [searchInput, setSearchInput] = useState(search || "");

  const headers =
    notificationList?.result?.length > 0
      ? Object.keys(notificationList.result[0]).filter(
          (key) => key !== "id"
        )
      : [];

  const editableFields = [

  ];

  const hasData = notificationList?.result?.length > 0;

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const openUpdateModal = () => setIsModalOpenUpdate(true);
  const closeUpdateModal = () => setIsModalOpenUpdate(false);

  // ✅ Sync search from redux
  useEffect(() => {
    setSearchInput(search || "");
  }, [search]);

  // ✅ Initial load
  useEffect(() => {
    dispatch(fetchNotification({ page: 1, search }));
  }, [dispatch]);

  // console.log(notificationList , "dddd")

  // ✅ Debounced search
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(fetchNotification({ page: 1, search: searchInput }));
    }, 800);

    return () => clearTimeout(timer);
  }, [searchInput]);

  // ✅ Page change
  useEffect(() => {
    dispatch(fetchNotification({ page: currentPage, search }));
  }, [currentPage]);

  // ✅ Page size change
  const handlePageSizeChange = (size) => {
    dispatch(setPageSize(size));
    dispatch(fetchNotification({ page: 1, search }));
  };

  // ✅ Loading state
  if (status === "loading") {
    return (
      <div className="w-full pt-20 flex justify-center">
        <Loader />
      </div>
    );
  }

  // ✅ Edit handlers
  const handleEdit = (rowId) => {
  const rowData = notificationList?.result?.find(
    (item) => item.id === rowId
  );

  setSelectedRow(rowData);
  setIsModalOpenUpdate(true);
};

  const handleSave = async () => {
    const {
      id,
      email,
      name,
      dateOfBirth,
      is_active,
      gender,
      country,
    } = editedData;

    const updatedData = {
      id,
      email,
      name,
      dateOfBirth,
      is_active,
      country,
      gender,
    };

    const resp = await dispatch(updateNotification(updatedData));

    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchNotification({ page: 1, search: searchInput}));
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field, val) => {
    if (["status", "active", "is_active", "is_blackList"].includes(field)) {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };

  // ✅ Log handler
  const handleLog = (id) => {
    const logData =
      notificationList?.Change_Log?.filter((f) => f.id === id)[0]
        ?.oldTrack || [];

    setCurrentLog(logData);
    openModal();
  };

  return (
    <div className="flex flex-col items-center">
      <PanelUserSearch value={searchInput} onChange={setSearchInput} />

      <div className="w-full flex items-center flex-col">
        <div className="max-w-[95%]">
          {hasData ? (
            <EditableTable
              headers={headers}
              rows={notificationList?.result || []}
              editRowId={editRowId}
              editedData={editedData}
              handleEdit={handleEdit}
              handleSave={handleSave}
              handleCancel={handleCancel}
              handleChange={handleChange}
              handleLog={handleLog}
              editableFields={editableFields}
              hideChangeLog={true}

            //   countryList={countryList}
            //   genderList={genderList}

            />
          ) : (
            <div className="w-full flex flex-col items-center justify-center py-20 text-gray-500">
              <div className="text-5xl mb-3">🔍</div>

              {searchInput ? (
                <>
                  <p className="text-lg font-medium">No results found</p>
                  <p className="text-sm mt-1">
                    for{" "}
                    <span className="font-semibold">
                      {searchInput}
                    </span>
                  </p>
                </>
              ) : (
                <>
                  <p className="text-lg font-medium">
                    No Data Available
                  </p>
                  <p className="text-sm mt-1">
                    There are no notifications to display
                  </p>
                </>
              )}
            </div>
          )}
        </div>

        {/* ✅ Pagination + Page size */}
        <div className="flex mt-4 items-center justify-between w-11/12">
          {!search && (
            <PageSizeSelector
              pageSize={pageSize}
              setPageSize={handlePageSizeChange}
            />
          )}

          {!search && (
            <SimplePagination
              currentPage={currentPage}
              setCurrentPage={(page) =>
                dispatch(fetchNotification({ page, search }))
              }
              totalPages={totalPages}
            />
          )}

           <button className="activeBtn text-sm text-white py-1 px-2 rounded" 
            onClick={openModal}
           >
           + Add Notification
        </button>
        </div>

         {/* Send SMS Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Send Notification"
        content={<AddNotification  onClose={closeModal} />}
      />

      <Modal
      isOpen={isModalOpenUpdate}
      onClose={closeUpdateModal}
      title="Update Notification"
      content={
        <UpdateNotification
          data={selectedRow}
          onClose={closeUpdateModal}
        />
      }
    />

        {/* ✅ Modal */}
        {/* <Modal
          isOpen={isModalOpen}
          onClose={closeModal}
          title="Change Log"
          content={<ChangeLog data={currentLog} />}
        /> */}
      </div>
    </div>
  );
}

export default Notification;